import { Extractor } from '@rcp/types';
import { RestSlice } from '../../../../../redux/rest.slice';
import { localizationService, Resource } from '../../../../../services';

export const haulerFacilityDevicesSlice = new RestSlice<Extractor>(
	localizationService.getLocalizedString('haulerPortal.haulerFacilityDetail.devices'),
	Resource.Extractors
);
export const haulerFacilityDevicesSliceReducer = haulerFacilityDevicesSlice.rests.reducer;
